import { useLang } from "@/lib/lang";
import { Eyebrow, MaskLines, Reveal } from "./motion";

const NUM = ["I", "II", "III"];

export const Company = () => {
  const { t } = useLang();
  const words = t.company.title.split(". ");
  const lines = words.map((w, i) => (i < words.length - 1 ? `${w}.` : w));
  return (
    <section id="company" className="relative mx-auto max-w-[1440px] px-5 md:px-10 py-24 md:py-40" data-testid="company-section">
      <div className="grid gap-16 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <Eyebrow>{t.company.eyebrow}</Eyebrow>
            <h2 className="mt-6 font-display text-[clamp(2.6rem,4.8vw,4.6rem)] leading-[0.98] text-[var(--ink)]">
              <MaskLines key={t.company.title} lines={lines} lineClass={(i) => (i === 1 ? "italic text-[var(--brass-deep)]" : "")} />
            </h2>
            <Reveal><p className="mt-8 max-w-md text-[15px] leading-relaxed text-[var(--ink-soft)]">{t.company.body}</p></Reveal>
          </div>
        </div>
        <div className="lg:col-span-7 lg:col-start-6">
          {t.company.pillars.map((p, i) => (
            <Reveal key={i} className="group relative grid grid-cols-[64px_1fr] md:grid-cols-[120px_1fr] gap-4 border-t border-[var(--line)] py-10 md:py-14 last:border-b" data-testid={`company-pillar-${i}`}>
              <span className="absolute top-[-1px] start-0 h-px w-0 bg-[var(--brass)] transition-[width] duration-1000 group-hover:w-full" />
              <span className="font-display text-5xl md:text-7xl leading-none text-[var(--brass)] transition-transform duration-700 group-hover:-translate-y-1" dir="ltr">{NUM[i]}</span>
              <div>
                <p className="text-[12px] uppercase tracking-[0.3em] text-[var(--brass-ink)]">{p.k}</p>
                <h3 className="mt-3 font-display text-3xl md:text-4xl leading-tight text-[var(--ink)]">{p.title}</h3>
                <p className="mt-4 max-w-xl text-[15px] leading-relaxed text-[var(--ink-soft)]">{p.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
